angular.module("modalDetailsPv.components", [])
  .component("modalDetailsPv", {
    templateUrl: "ng/components/modalDetailsPv/modalDetailsPv.view.html",
    bindings: {},
    controller: ModalDetailPvController,
    controllerAs: "modalDetailPvCtrl"

  })

function ModalDetailPvController(
  $modalService,
  $rootScope,
  $transactionFactory,
  $download,
  $arcService
) {
  var self = this;

  self.$onInit = function () {
    self.model = $transactionFactory.get();
    getMessages()
  }

  self.closeModal = function () {

    $modalService.closeModal("modalDetailsPv");
    $rootScope.openModalDetailsPV = false;
  }

  self.generdownloadDoc = function (file) {
    var input = {
      downloadKey: file.downloadKey
    }
    var url = "/uni/downloadDocPv/service-infos/";
    $download.getGenericDownload(url, input)
      .then(function (response) {
        console.log(response)
      })

  }

  var getMessages = function () {
    self.isLoadingMessageSection = true;
    $arcService
      .getMessagesPvAg(self.model.id)
      .then(function (response) {
        self.messagesVisible = response.visible;
        self.listOfMessages = response.messages;
        self.isLoadingMessageSection = false;
      })
      .catch(function (err) {
        console.log(err);
        self.isLoadingMessageSection = false;
      });
  };

  self.setMessages = function (index, message, newMessage) {
    self.isSendingMessage = [];
    self.isSendingMessage[index] = true;
    $arcService
      .setMessagePvToAg(
        message.practiceId,
        message.conversationId,
        newMessage
      )
      .then(function (response) {
        if (response.success) {
          getMessages();
          self.newMessage[index] = null;
        } else {
          $rootScope.$broadcast("addAlert", {
            text: "ERROR_GENERIC",
          });
        }
        self.isSendingMessage[index] = false;
      })
      .catch(function (err) {
        self.isSendingMessage[index] = false;
        console.log(err);
      });
  };
}